"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textMixin = void 0;

var _styledSystem = require("styled-system");

var textColor = (0, _styledSystem.style)({
  prop: "textColor",
  cssProperty: "color",
  key: "colors"
});
/** styled functions for Text */

var textMixin = (0, _styledSystem.compose)(_styledSystem.typography, _styledSystem.color, textColor);
exports.textMixin = textMixin;
//# sourceMappingURL=Text.shared.js.map